import styles from './CountBadge.module.scss';

const MAX_DISPLAY_COUNT = 99;

type Props = {
  count: number;
  className?: string;
};

export const CountBadge = ({ count, className }: Props) => {
  if (count <= 0) return null;
  const label = count > MAX_DISPLAY_COUNT ? `${MAX_DISPLAY_COUNT}+` : count;
  return <span className={className ? `${styles.badge} ${className}` : styles.badge}>{label}</span>;
};
